import React from "react";
import { TLandingLayout } from "stories/layouts/TLandingLayout";
import { connect, useDispatch } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { GlobalState } from "store";
import { Home } from "@material-ui/icons";
import { AuthService, FirebaseService, OAuthUser } from "services/AuthService";
import { IconButton } from "@material-ui/core";
import { useTopMenus } from "menus";
import { useTranslation } from "react-i18next";
import { SplashScreenPage } from "pages/SplashScreenPage";

const companyName = process.env.REACT_APP_COMPANY_NAME;

const CompanyName = ({ history }: RouteComponentProps) => {
  const onHomeClickHandler = () => {
    history.push("/");
  };

  return (
    <IconButton
      color="inherit"
      title={companyName}
      onClick={onHomeClickHandler}>
      <Home />
    </IconButton>
  );
};

const LandingLayoutComponent = ({ children, user, authService = FirebaseService.getInstance(), history }: LandingLayoutProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const topMenus = useTopMenus(user?.displayName, dispatch, history, t, authService);

  const CompanyNameWithRouter = withRouter(CompanyName);

  if (!user) {
    return <SplashScreenPage/>
  }

  return (
    <TLandingLayout
      companyName={<CompanyNameWithRouter/>}
      topMenus={topMenus}>
      {children}
    </TLandingLayout>
  );
};

export interface LandingLayoutProps extends RouteComponentProps {
  children: React.ReactElement
  user: OAuthUser
  authService?: AuthService
}

const mapStateToProps = (state: GlobalState) => {
  return {
    user: state.session.user
  };
};

export const LandingLayout = connect(mapStateToProps)(withRouter(LandingLayoutComponent));